import { Button, Group, Modal, ModalCloseReason, Label, Toggle } from '@economic/gaudi';
import React from 'react';

import { Field } from '../../../../../../shared/components/Form';
import { t } from '../../../../../../shared/components/l10n/l10n';
import { DisplayMessages } from '../../../shared/components/DisplayMessages';
import { BookOnlyConfirmationDialogContent } from '../BookOnlyConfirmationDialogContent';
import { BookAndSendFormData, SendByType } from '../types';

export function BookDraftEInvoiceDialogContent({
    note,
    information,
    formAction: onBookAndSendAction,
    onConvertToEmail,
    onCancel,
    onToggleMoneyflow,
}: {
    note: React.ReactNode;
    information: BookAndSendFormData;
    formAction: (sendByType: SendByType) => void;
    onConvertToEmail: () => void;
    onCancel?: (reason: ModalCloseReason) => void;
    onToggleMoneyflow: () => void;
}) {
    const onBookOnlyAction = () =>
        information.skipBookOnlyConfirmation ? onBookAndSendAction(SendByType.undefined) : setBookOnlyConfirmation(true);
    const [showBookOnlyConfirmation, setBookOnlyConfirmation] = React.useState<boolean>(false);

    if (showBookOnlyConfirmation) {
        return (
            <BookOnlyConfirmationDialogContent
                onBack={() => setBookOnlyConfirmation(false)}
                onOk={() => onBookAndSendAction(SendByType.undefined)}
                text={t`FORM_BOOKANDSEND_BOOK_ONLY_CONFIRMATION_TEXT`}
            />
        );
    }

    const isMoneyflowOfferToggled = information.moneyflowOffer?.toggled;
    const secondaryButton = isMoneyflowOfferToggled ? (
        <Button type="submit" onClick={() => onCancel && onCancel('close')}>{t`FORM_BOOKANDSEND_CANCEL`}</Button>
    ) : (
        <Button
            type="submit"
            className="book-and-send-dialog__action-button"
            onClick={() => onBookOnlyAction()}>{t`FORM_BOOKANDSEND_BOOK_TEXT`}</Button>
    );

    return (
        <>
            <Modal.Header>
                {t(`FORM_BOOKANDSEND_INVOICE_HEADER`, {
                    DOCUMENT_TYPE: information.isCreditNote
                        ? t(`FORM_BOOKANDSEND_DOCUMENT_TYPE_CREDIT_NOTE`)
                        : t(`FORM_BOOKANDSEND_DOCUMENT_TYPE_DRAFT_INVOICE`),
                })}
            </Modal.Header>

            <Modal.Content>
                {note}
                <Button className="book-and-send-dialog__btn-show-options" appearance="discrete" onClick={onConvertToEmail}>
                    {t`FORM_BOOKANDSEND_CONVERT_TO_EMAIL`}
                </Button>
                <div className="book-and-send-dialog__messages">
                    {information.messages && <DisplayMessages messages={information.messages} />}
                </div>
                <div className="book-and-send-dialog__options">
                    <Field.Checkbox name="emailOptions.showPdf" text={t`FORM_BOOKANDSEND_SHOW_INVOICE`} />
                    {information.canToggleMoneyflow && (
                        <div className="field field--no-height">
                            <Label>
                                <Toggle
                                    text={t`FORM_BOOKANDSEND_MONEYFLOW_TOGGLE`}
                                    checked={!!information.moneyflowOffer?.toggled}
                                    onChange={() => onToggleMoneyflow()}
                                />
                            </Label>
                        </div>
                    )}
                </div>
                <Field.Hidden name="sendByType" value={Number(SendByType.undefined)} />
            </Modal.Content>

            <Modal.Footer>
                <Group>
                    {secondaryButton}

                    <Button
                        className="book-and-send-dialog__action-button"
                        appearance="primary"
                        onClick={() => onBookAndSendAction(SendByType.oioxml)}
                        autoFocus>
                        {t`FORM_BOOKANDSEND_SEND_TEXT`}
                    </Button>
                </Group>
            </Modal.Footer>
        </>
    );
}
